import { render } from "./FirstSection.vue?vue&type=template&id=09bf923a"
import script from "./FirstSection.vue?vue&type=script&lang=js"
export * from "./FirstSection.vue?vue&type=script&lang=js"

import "./FirstSection.vue?vue&type=style&index=0&id=09bf923a&lang=scss"

import exportComponent from "/var/www/production/declic-center-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__